module.exports = __webpack_public_path__ + "static/media/logo.93b4199b.png";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/logo.png
// module id = 261
// module chunks = 0